import styled from 'styled-components';

export const CustomModalHeader = styled.div`
  position: relative; // Added to position the pseudo-element
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 32px;
  margin-bottom: 48px;
  background: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  background: linear-gradient(180deg, ${({ theme }) => theme?.colors?.theme?.brandColor2} 0%, ${({ theme }) => theme?.colors?.theme?.brandColor3} 100%);

  &::after {
    content: '';
    position: absolute;
    bottom: -48px;  // Adjust this value to position the semicircle
    left: 50%;
    transform: translateX(-50%);
    width: 100%;    // Adjust width of the semicircle
    height: 64px;   // Half the width for a perfect semicircle
    background: ${({ theme }) => theme?.colors?.theme?.brandColor3};
    border-bottom-left-radius: 100%;
    border-bottom-right-radius: 100%;
  }
`;

export const CustomModalBody = styled.div`
  padding: 16px;
`;

export const CustomModalFooter = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 16px;
  padding: 16px;
`;